package kpt.core.database.watchlist.dao

import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.coroutines.createFlow
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import kotlin.Boolean
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlinx.coroutines.flow.Flow
import kpt.core.database.watchlist.entity.WatchlistEntity

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "OPT_IN_USAGE_ERROR", "OPT_IN_USAGE", "MemberExtensionConflict", "CAN_BE_VAL"])
internal class WatchlistDao_Impl(
  __db: RoomDatabase,
) : WatchlistDao {
  private val __db: RoomDatabase

  private val __insertAdapterOfWatchlistEntity: EntityInsertAdapter<WatchlistEntity>
  init {
    this.__db = __db
    this.__insertAdapterOfWatchlistEntity = object : EntityInsertAdapter<WatchlistEntity>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `personal_watchlist` (`coinId`,`addedAtMs`) VALUES (?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: WatchlistEntity) {
        statement.bindText(1, entity.coinId)
        statement.bindLong(2, entity.addedAtMs)
      }
    }
  }

  public override suspend fun insert(entry: WatchlistEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfWatchlistEntity.insert(_connection, entry)
  }

  public override fun observeAll(): Flow<List<WatchlistEntity>> {
    val _sql: String = "SELECT * FROM personal_watchlist ORDER BY addedAtMs DESC"
    return createFlow(__db, false, arrayOf("personal_watchlist")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfCoinId: Int = getColumnIndexOrThrow(_stmt, "coinId")
        val _columnIndexOfAddedAtMs: Int = getColumnIndexOrThrow(_stmt, "addedAtMs")
        val _result: MutableList<WatchlistEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: WatchlistEntity
          val _tmpCoinId: String
          _tmpCoinId = _stmt.getText(_columnIndexOfCoinId)
          val _tmpAddedAtMs: Long
          _tmpAddedAtMs = _stmt.getLong(_columnIndexOfAddedAtMs)
          _item = WatchlistEntity(_tmpCoinId,_tmpAddedAtMs)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun observeContains(coinId: String): Flow<Boolean> {
    val _sql: String = "SELECT EXISTS(SELECT 1 FROM personal_watchlist WHERE coinId = ?)"
    return createFlow(__db, false, arrayOf("personal_watchlist")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, coinId)
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun observeById(coinId: String): Flow<WatchlistEntity?> {
    val _sql: String = "SELECT * FROM personal_watchlist WHERE coinId = ?"
    return createFlow(__db, false, arrayOf("personal_watchlist")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, coinId)
        val _columnIndexOfCoinId: Int = getColumnIndexOrThrow(_stmt, "coinId")
        val _columnIndexOfAddedAtMs: Int = getColumnIndexOrThrow(_stmt, "addedAtMs")
        val _result: WatchlistEntity?
        if (_stmt.step()) {
          val _tmpCoinId: String
          _tmpCoinId = _stmt.getText(_columnIndexOfCoinId)
          val _tmpAddedAtMs: Long
          _tmpAddedAtMs = _stmt.getLong(_columnIndexOfAddedAtMs)
          _result = WatchlistEntity(_tmpCoinId,_tmpAddedAtMs)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun delete(coinId: String) {
    val _sql: String = "DELETE FROM personal_watchlist WHERE coinId = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, coinId)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteAll() {
    val _sql: String = "DELETE FROM personal_watchlist"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
